import { LocationPath } from '../location';
import { Translation } from '../translation';

/**
 * Maps to LotItemType enum in backend (Sierra.Inventory.Models.Enums.LotItemType)
 */
export enum LotItemType {
  LotItem = 0,
  Roll = 1,
  Chemical = 2,
}

/**
 * Search command for lot item paginated search
 * Maps to LotItemSearchCommand in backend
 */
export interface LotItemSearchCommand {
  lotItemNumbers?: string[];
  searchTerm?: string; // partial, case-insensitive match on the lot item number

  itemCodes?: string[];
  locationPaths?: LocationPath[];
  providerReferences?: string[];
  manufacturerReferences?: string[];
  manufacturerLotNumbers?: string[];
  manufacturerLabelNumbers?: string[];
  invoiceReferences?: string[];
  deliveryNoteReferences?: string[];
  excludeZeroBalances?: boolean;
  excludeSplitLotItems?: boolean;
  batchReferences?: string[];
  lotItemTypes?: LotItemType[];
}

/**
 * Numbered document key for references like Invoice, PO, etc.
 */
export interface NumberedDocumentKey {
  reference?: string;
  number?: string;
}

/**
 * Named document key for business entities like Provider, Manufacturer
 */
export interface NamedDocumentKey {
  code?: string;
  reference?: string;
  name?: string;
}

/**
 * Individual lot item search result
 * Maps to LotItemSearchResultItem in backend
 */
export interface LotItemSearchResultItem {
  number: string;
  itemCode: string;
  itemDisplayName: Translation;
  parentKey?: { reference?: string; number?: string };
  invoice?: NumberedDocumentKey;
  purchaseOrder?: NumberedDocumentKey;
  workOrder?: NumberedDocumentKey;
  deliveryNote?: NumberedDocumentKey;
  provider?: NamedDocumentKey;
  manufacturer?: NamedDocumentKey;
  manufacturerLotNumber?: string;
  manufacturerLabelNumber?: string;
  packagingType: number;
  client?: NamedDocumentKey;
  currentLocationCode: string;
  currentLocationName: Translation;
  currentLocationPathNames?: Translation[];
  currentQuantity: number;
  netQuantity: number;
  originalQuantity: number;
}
